import { render, staticRenderFns } from "./PraticaAutotrasportoTrackingDemo.vue?vue&type=template&id=c2b0f328&"
import script from "./PraticaAutotrasportoTrackingDemo.vue?vue&type=script&lang=js&"
export * from "./PraticaAutotrasportoTrackingDemo.vue?vue&type=script&lang=js&"
import style0 from "./PraticaAutotrasportoTrackingDemo.vue?vue&type=style&index=0&id=c2b0f328&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2b0f328')) {
      api.createRecord('c2b0f328', component.options)
    } else {
      api.reload('c2b0f328', component.options)
    }
    module.hot.accept("./PraticaAutotrasportoTrackingDemo.vue?vue&type=template&id=c2b0f328&", function () {
      api.rerender('c2b0f328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaAutotrasportoTrackingDemo.vue"
export default component.exports